import type { Sample } from '../app/types.ts';

const W = 220;
const H = 36;
const PAD = 2;

interface SparklineProps {
  samples: Sample[];
  field: 'rooms' | 'connections' | 'tickMsMax' | 'gapMsMax';
  color: string;
  label: string;
}

/** Tiny SVG sparkline over the session history buffer (no axes, no chrome). */
export function Sparkline({ samples, field, color, label }: SparklineProps) {
  if (samples.length < 2) {
    return (
      <div class="spark">
        <div class="spark-label">{label}</div>
        <div class="spark-empty">collecting…</div>
      </div>
    );
  }
  const values = samples.map((s) => s[field]);
  const max = Math.max(...values, 1e-6);
  const points = values
    .map((v, i) => {
      const x = PAD + (i / (values.length - 1)) * (W - 2 * PAD);
      const y = H - PAD - (v / max) * (H - 2 * PAD);
      return `${x.toFixed(1)},${y.toFixed(1)}`;
    })
    .join(' ');
  const last = values[values.length - 1];
  return (
    <div class="spark">
      <div class="spark-label">
        {label} <span class="spark-value">{last < 10 ? last.toFixed(1) : Math.round(last)}</span>
      </div>
      <svg viewBox={`0 0 ${W} ${H}`} preserveAspectRatio="none" aria-hidden="true">
        <polyline points={points} fill="none" stroke={color} stroke-width="1.5" />
      </svg>
    </div>
  );
}
